import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const AudioIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 13,
  height = 10,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 13 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Podcast</title>
      <path
        d="M6.648.463 3.471 3.212H.463v3.537h2.962l3.223 2.788V.463Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.841.042c.165.075.27.24.27.421v9.074a.463.463 0 0 1-.766.35L3.253 7.212H.463A.463.463 0 0 1 0 6.749V3.212c0-.256.207-.463.463-.463h2.835L6.345.113a.463.463 0 0 1 .496-.071Zm-.656 1.434L3.774 3.562a.463.463 0 0 1-.303.113H.926v2.61h2.5c.11 0 .218.04.302.113l2.457 2.126V1.476ZM10.474.145c.2-.16.49-.128.65.071a7.65 7.65 0 0 1 0 9.583.463.463 0 0 1-.721-.58 6.725 6.725 0 0 0 0-8.423.463.463 0 0 1 .07-.65Zm-1.19 1.192a.463.463 0 0 1 .648.098 6.02 6.02 0 0 1 0 7.145.463.463 0 1 1-.745-.55 5.094 5.094 0 0 0 0-6.045.463.463 0 0 1 .098-.648ZM7.99 2.638a.463.463 0 0 1 .642.133 4.075 4.075 0 0 1 0 4.473.463.463 0 0 1-.775-.508 3.15 3.15 0 0 0 0-3.456.463.463 0 0 1 .133-.642Z"
        fill={fill}
      />
    </svg>
  );
};

export default AudioIcon;
